<template>
  <div :class="state" style="background: rgb(242, 246, 250);height: auto;padding-bottom: 1rem">
    <div class="wrapper">
      <div class="title">
        <span>产品介绍</span>
        <span class="line-separator"></span>
      </div>
      <el-row class="main-row" v-if="state==='pc'">
        <div class="wrapper">
          <el-row :gutter="24" style="margin-top: .2rem;">
            <el-col :span="6" v-for="(item, index) in productType" :key="index" @click="go(item.value)">
              <div :class="'main-product-type '">
                <img class="img" :src="getImage(item.img)"/>
                <div class="name">{{ item.text }}</div>
                <div class="description">{{ item.description }}<div class="subType">{{ item.subType }}</div></div>
                <div class="more">More ></div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="24" style="margin-top: .2rem;">
            <el-col :span="6" v-for="(item, index) in productTypeList2" :key="index" @click="go(item.value)">
              <div :class="'main-product-type '">
                <img class="img" :src="getImage(item.img)"/>
                <div class="name">{{ item.text }}</div>
                <div class="description">{{ item.description }}<div class="subType">{{ item.subType }}</div></div>
                <div class="more">More ></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>
      <el-row class="main-row"  v-else-if="state==='mobile'">
        <div class="wrapper">
          <el-row :gutter="24" style="margin: .2rem ;">
            <el-col style="margin-bottom: .5rem" :span="12" v-for="(item, index) in productType" :key="index" @click="go(item.value)">
              <div :class="'main-product-type '">
                <img class="img" :src="getImage(item.img)"/>
                <div class="name">{{ item.text }}</div>
                <div class="more">More ></div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24" style="margin: .2rem ;">
            <el-col style="margin-bottom: .5rem" :span="12" v-for="(item, index) in productTypeList2" :key="index" @click="go(item.value)">
              <div :class="'main-product-type '">
                <img class="img" :src="getImage(item.img)"/>
                <div class="name">{{ item.text }}</div>
                <div class="more">More ></div>
              </div>
            </el-col>
          </el-row>


        </div>
      </el-row>


    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    productType: {
      type: Array,
      default: () => [],
    },
    more: {
      type: Boolean,
      default: () => false
    }
  },
  setup() {
    const router = useRouter()
    const go = (mainType, subType) => {
      let params = {
        mainType: mainType,
        subType: subType
      }
      //router.push({ name: 'Product', query: { userId: '123' }})

      router.push({ name: 'Product', query: { 'type': mainType } })
    }
    const state = computed(() => useStore().state.client);
    const productTypeList2 = productTypes2
    return {
      router,
      go,
      state,
      productTypeList2
    }
  },
  methods: {
    getImage(fileRef) {
      return require("@/assets/images/types/" + fileRef)
    },
  },
};
</script>

<style lang="scss" scoped>


.pc {
  padding-top: 0.01rem;
}

.mobile {
  padding-top: 0.01rem;
  .main-product-type{
    .name{
      margin-top: .0rem;
    }
  }
}

.container {
  width: 100%;
}

.main-product-type {
  cursor: pointer;
  padding: .2rem;
  text-align: center;
  background: white;
  border-radius: 12px;
  box-shadow: -0.347296px 1.969616px 24px rgb(209 223 236 / 91%);

  .img {
    height: 1.2rem;
    text-align: center;
  }

  .name {
    margin-top: .0rem;
    height: .5rem;
    text-align: center;
    color: #254b7c;
    font-weight: 600;
    font-size: .28rem;
  }

  .subType {
    text-align: center;
    color: #06172d;
    margin-top: .015rem;
    font-size: .15rem;
    font-weight: bold;
  }

  .description {
    height: 1.3rem;
    text-align: center;
    color: rgb(151, 162, 177);
    font-size: .15rem;
  }

  .more {
    text-align: center;
    color: #cf261c;
    font-size: .15rem;
    font-weight: 600;
  }

  transition: .3s  transform;
}

.main-product-type:hover{
  transform: translateY(-5px) ;
}


</style>
